export default __webpack_public_path__ + "static/media/s3.c09ee7fe.jpg";